import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal, Popover, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router";
import {
	CostItemsDiagnosticProduct,
	DiagnosticProductTransaction,
	DiagnosticProductTransactionResponse,
	LayerDiagnosticProductTransaction,
	LayerItemDiagnosticProductTransactionApi,
} from "src/services/Api/Organization/types";
import { ReactComponent as InfoCircleSVG } from "go-component/images/svg/info-circle.svg";
import FormatDate from "go-core/components/Formatters/FormatDate";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { LoadingContainer } from "go-core/components/Loading";
import { ReactComponent as PreviewArrowSVG } from "go-core/images/svg/actions/preview-arrow.svg";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import SubmenuProductDiagnosticNavigation from "../../components/SubmenuProductDiagnosticNavigation";

const OrganizationSettingsDiagnosticProductTransactionsPage = () => {
	const [transactions, setTransactions] = useState<DiagnosticProductTransactionResponse[] | undefined>(undefined);
	const [modalCostTransaction, setModalCostTransaction] = useState<DiagnosticProductTransaction | undefined>(
		undefined
	);
	const [modalLayerTransaction, setModalLayerTransaction] = useState<DiagnosticProductTransaction | undefined>(
		undefined
	);
	const [loading, setLoading] = useState<boolean>(true);
	const { search } = useLocation();
	const searchParams = useMemo(() => new URLSearchParams(search), [search]);
	const params = Object.fromEntries(searchParams);
	const productId = Number(params.product_id);

	const fetch = async (productId: number) => {
		if (params.only_error === undefined) params.only_error = "1";

		const data = await apiOrganization.getOrganizationDiagnosticProductTransactions(productId, params);
		setTransactions(data);
		setLoading(false);
	};
	useEffect(() => {
		if (productId !== undefined) {
			fetch(productId);
		}
	}, []);

	const popover = (
		<Popover id="popover-basic">
			<Popover.Header as="h3">Transakcje</Popover.Header>
			<Popover.Body>
				And here's some <strong>amazing</strong> content. It's very engaging. right?
			</Popover.Body>
		</Popover>
	);

	if (!productId) return <>Produkt nie istnieje</>;
	if (loading) return <LoadingContainer />;
	const isModalShow = modalCostTransaction !== undefined;
	const showCostTransaction = (transaction: DiagnosticProductTransaction) => {
		setModalCostTransaction(transaction);
	};
	const showLayerTransaction = (transaction: DiagnosticProductTransaction) => {
		setModalLayerTransaction(transaction);
	};
	const renderCosts = (costs: CostItemsDiagnosticProduct[], i: number | undefined) => {
		if (costs.length <= 0) return null;
		if (i === undefined) i = 0;
		i = i + 1;
		if (i > 5) return null;

		return (
			<p className={"m-0"}>
				{costs.map((cost: CostItemsDiagnosticProduct) => {
					return (
						<div key={cost.layer_id} style={{ paddingLeft: 20 }}>
							{FormatDate(cost.date)}
							{" | "}
							{cost.amount} szt za {cost.price} zł
							<small>
								{cost.document_type} <a href={""}>{cost.document_number}</a>{" "}
								<small>(T: {cost.transaction_id})</small>
							</small>
							{renderCosts(cost.costs, i)}
						</div>
					);
				})}
			</p>
		);
	};
	const renderLayers = (layer: LayerDiagnosticProductTransaction) => {
		return (
			<>
				{/*{FormatDate(cost.date)}{" | "}*/}
				{layer.amount} szt za {layer.price} zł
				<small>
					(OPEN: {layer.open_amount} szt za {layer.open_price})
				</small>
				{layer.items.map((item: LayerItemDiagnosticProductTransactionApi) => {
					return (
						<div key={item.transaction_id} style={{ paddingLeft: 20 }}>
							{FormatDate(item.date)}
							{" | "}
							{item.amount} szt za {item.price} zł
							<small>
								{item.document_type} <a href={""}>{item.document_number}</a>{" "}
								<small>(T: {item.transaction_id})</small>
							</small>
						</div>
					);
				})}
			</>
		);
	};
	return (
		<div>
			<SubmenuProductDiagnosticNavigation id={productId} />
			<Modal show={isModalShow} onHide={() => setModalCostTransaction(undefined)}>
				{modalCostTransaction && (
					<>
						<Modal.Header closeButton>
							<Modal.Title>Koszty {modalCostTransaction.transaction_id}</Modal.Title>
						</Modal.Header>
						<Modal.Body>{renderCosts(modalCostTransaction.costs, 0)}</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={() => setModalCostTransaction(undefined)}>
								Close
							</Button>
						</Modal.Footer>
					</>
				)}
			</Modal>
			<Modal show={modalLayerTransaction !== undefined} onHide={() => setModalLayerTransaction(undefined)}>
				{modalLayerTransaction && (
					<>
						<Modal.Header closeButton>
							<Modal.Title>
								Rozchody T:{modalLayerTransaction.layer.source_id}, L:
								{modalLayerTransaction.layer.layer_id}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>{renderLayers(modalLayerTransaction.layer)}</Modal.Body>
						<Modal.Footer>
							<Button variant="secondary" onClick={() => setModalLayerTransaction(undefined)}>
								Close
							</Button>
						</Modal.Footer>
					</>
				)}
			</Modal>
			<Tabs
				defaultActiveKey={
					transactions !== undefined && transactions?.length > 0
						? `nav_stock_${transactions[0].stock_id}`
						: ""
				}
				id="diagnostic_stocks"
				className="mb-3"
			>
				{transactions?.map((dataStock) => {
					return (
						<Tab
							eventKey={`nav_stock_${dataStock.stock_id}`}
							title={`${dataStock.name} (${dataStock.stock_id})`}
							key={dataStock.stock_id}
						>
							<div>
								<table className="table">
									<thead>
										<tr>
											<th style={{ width: 1, paddingLeft: 0, paddingRight: 0 }}></th>
											<th>Data</th>
											<th>Dokument</th>
											<th>Ilość</th>
											<th>Kwota</th>
											<th>Suma</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{dataStock.products.map((transaction: DiagnosticProductTransaction) => {
											return (
												<tr key={transaction.transaction_id}>
													<td style={{ width: 1, paddingLeft: 0, paddingRight: 0 }}>
														{transaction.costs.length > 0 && (
															<button
																className={"btn btn-light btn-sm"}
																onClick={() => showCostTransaction(transaction)}
															>
																<InfoCircleSVG />
															</button>
														)}
													</td>
													<td>
														{FormatDate(transaction.date)}
														{" | "}
														{transaction.transaction_id}
													</td>
													<td>
														{transaction.document_type}{" "}
														<a href={""}>{transaction.document_number}</a>
													</td>
													<td>{transaction.amount}</td>
													<td>{transaction.price}</td>
													<td>
														{`${transaction.sum_amount} szt o wartości ${FormatMoney({
															amount: transaction.sum_price,
															currency: "PLN",
														})}`}
													</td>
													<td>
														{transaction.layer && (
															<button
																className={"btn btn-light btn-sm"}
																onClick={() => showLayerTransaction(transaction)}
															>
																<PreviewArrowSVG />
															</button>
														)}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</Tab>
					);
				})}
			</Tabs>
		</div>
	);
};

export default OrganizationSettingsDiagnosticProductTransactionsPage;
